<script setup lang="ts">
import { computed } from 'vue'

import { LogOut, User } from 'lucide-vue-next'

import { Button } from '@/components/ui/button'
import { useUserStore } from '@/stores/userStore'
import type { IUser } from '@/types/UserTypes'

const userStore = useUserStore()

const userData = computed<IUser | null>(() => userStore.userData)
</script>

<template>
  <div class="flex items-center gap-3">
    <div class="flex items-center gap-2">
      <User class="size-4" />
      <span>{{ userData?.firstName }} {{ userData?.lastName }}</span>
    </div>

    <Button
      variant="ghost"
      class="cursor-pointer"
      :aria-label="$t('profile.logout')"
      @click="userStore.logout"
    >
      <LogOut class="size-4" />
    </Button>
  </div>
</template>
